/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Speaker_Id_ConfirmInputs */

const en_automatic_speaker_id_confirm = /** @type {(inputs: Automatic_Speaker_Id_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This process will attempt to automatically assign speakers to the Events in the current Event Group. Would you like to proceed?`)
};

const fr_automatic_speaker_id_confirm = /** @type {(inputs: Automatic_Speaker_Id_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce processus tentera d'attribuer automatiquement des intervenants aux événements du groupe d'événements actuel. Souhaitez-vous continuer ?`)
};

const de_automatic_speaker_id_confirm = /** @type {(inputs: Automatic_Speaker_Id_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Prozess versucht, den Veranstaltungen in der aktuellen Veranstaltungsgruppe automatisch Sprecher zuzuordnen. Möchten Sie fortfahren?`)
};

const it_automatic_speaker_id_confirm = /** @type {(inputs: Automatic_Speaker_Id_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo processo tenterà di assegnare automaticamente i relatori agli eventi nel gruppo di eventi corrente. Vuoi procedere?`)
};

const ru_automatic_speaker_id_confirm = /** @type {(inputs: Automatic_Speaker_Id_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В ходе этого процесса будет предпринята попытка автоматически назначить докладчиков на мероприятия в текущей группе мероприятий. Вы хотите продолжить?`)
};

const es_automatic_speaker_id_confirm = /** @type {(inputs: Automatic_Speaker_Id_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este proceso intentará asignar automáticamente oradores a los eventos del grupo de eventos actual. ¿Desea continuar?`)
};

const zh_cn2_automatic_speaker_id_confirm = /** @type {(inputs: Automatic_Speaker_Id_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此过程将尝试自动为当前活动组中的活动分配演讲者。您是否要继续？`)
};

const ja_automatic_speaker_id_confirm = /** @type {(inputs: Automatic_Speaker_Id_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプロセスでは、現在のイベントグループ内のイベントにスピーカーを自動的に割り当てようとします。続行しますか?`)
};

const hi_automatic_speaker_id_confirm = /** @type {(inputs: Automatic_Speaker_Id_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस प्रक्रिया के तहत मौजूदा इवेंट ग्रुप में मौजूद इवेंट्स के लिए वक्ताओं को स्वचालित रूप से असाइन करने का प्रयास किया जाएगा। क्या आप आगे बढ़ना चाहेंगे?`)
};

const pt_pt2_automatic_speaker_id_confirm = /** @type {(inputs: Automatic_Speaker_Id_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este processo tentará atribuir automaticamente os oradores aos eventos no grupo de eventos atual. Deseja prosseguir?`)
};

/**
* | output |
* | --- |
* | "This process will attempt to automatically assign speakers to the Events in the current Event Group. Would you like to proceed?" |
*
* @param {Automatic_Speaker_Id_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_speaker_id_confirm = /** @type {((inputs?: Automatic_Speaker_Id_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Speaker_Id_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_speaker_id_confirm(inputs)
	if (locale === "de") return de_automatic_speaker_id_confirm(inputs)
	if (locale === "it") return it_automatic_speaker_id_confirm(inputs)
	if (locale === "ru") return ru_automatic_speaker_id_confirm(inputs)
	if (locale === "es") return es_automatic_speaker_id_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_speaker_id_confirm(inputs)
	if (locale === "ja") return ja_automatic_speaker_id_confirm(inputs)
	if (locale === "hi") return hi_automatic_speaker_id_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_speaker_id_confirm(inputs)
	return en_automatic_speaker_id_confirm(inputs)
});